"use strict";
//@ts-nocheck
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEquipmentReportPhotos = exports.sendEquipmentReport = exports.createEquipmentReport = exports.getAllPaperworks = exports.driverUpdateDwellTime = exports.rotatePhotoRight = exports.deleteSavedTable = exports.createSavedTable = exports.updateSavedTables = exports.fetchSavedTable = exports.fetchSavedTables = exports.deleteLoadDocumentPhotos = exports.deleteLoadDocumentFilesWeb = exports.createLoadDocumentPhotos = exports.createLoadDocumentFilesWeb = exports.createLoadDocumentPhotosWeb = exports.deleteLoadDocument = exports.updateLoadDocument = exports.createLoadDocumentWeb = exports.createLoadDocument = exports.fetchLoadDocument = exports.deleteLoadReport = exports.updateLoadReport = exports.createLoadReport = exports.fetchLoadReport = exports.dispatcherUpdatePriority = exports.dispatcherUpdateLoadStatus = exports.dispatcherAssignDriver = exports.updateLoadStatus = exports.fetchLegETAByLinkId = exports.fetchLoadETAByManifestLinkId = exports.fetchLoadETA = exports.fetchLoadUnits = exports.fetchLoadTypes = exports.fetchVehicleType = exports.fetchTruck = exports.fetchAllOrderLegByOrderLegLinkId = exports.fetchOrderLegByBillOfLading = exports.fetchOrderLegByOrderLegLinkId = exports.fetchLoadByManifestLinkId = exports.updateFullLoad = exports.updateLoadBOL = exports.updateLoad = exports.updateLoadCounts = exports.fetchLoadCounts = exports.fetchOrderLeg = exports.fetchLoad = exports.fetchVisibleTableRows = exports.fetchLoadTableRows = exports.fetchLoads = void 0;
exports.updatePhotoIssueReport = exports.createPhotoIssueReport = exports.deleteDriverLoadDocuments = exports.deleteDriverLoadPhotos = exports.createDriverLoadDocuments = exports.createDriverLoadPhotos = exports.sendDriverLoadReport = exports.createDriverLoadReport = exports.deleteEquipmentReportPhotos = void 0;
var qs_1 = __importDefault(require("qs"));
var snakecase_keys_1 = __importDefault(require("snakecase-keys"));
var config_1 = __importDefault(require("../../config"));
var base_1 = require("./base");
var fetchLoads = function (token, querystring, url) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(url ? "".concat(url) : "".concat(config_1.default.urls.loads, "?").concat(qs_1.default.stringify(querystring))), token, 'GET')];
    });
}); };
exports.fetchLoads = fetchLoads;
var fetchLoadTableRows = function (token, querystring, url) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(url ? "".concat(url) : "".concat(config_1.default.urls.loads, "table/?").concat(qs_1.default.stringify(querystring))), token, 'GET')];
    });
}); };
exports.fetchLoadTableRows = fetchLoadTableRows;
var fetchVisibleTableRows = function (token, querystring, url) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(url
                ? "".concat(url)
                : "".concat(config_1.default.urls.loads, "visible/?").concat(qs_1.default.stringify(querystring))), token, 'GET')];
    });
}); };
exports.fetchVisibleTableRows = fetchVisibleTableRows;
var fetchLoad = function (token, loadID) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "orders/").concat(loadID, "/"), token, 'GET')];
}); }); };
exports.fetchLoad = fetchLoad;
var fetchOrderLeg = function (token, loadID) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads).concat(loadID, "/"), token, 'GET')];
}); }); };
exports.fetchOrderLeg = fetchOrderLeg;
var fetchLoadCounts = function (token, querystring) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "counts/?").concat(qs_1.default.stringify(querystring)), token, 'GET', undefined, undefined, false)];
    });
}); };
exports.fetchLoadCounts = fetchLoadCounts;
var updateLoadCounts = function (token, querystring, columnOrdering) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "counts/?").concat(qs_1.default.stringify(querystring)), token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(columnOrdering)), false)];
    });
}); };
exports.updateLoadCounts = updateLoadCounts;
var updateLoad = function (token, loadID, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads).concat(loadID, "/"), token, 'PATCH', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.updateLoad = updateLoad;
var updateLoadBOL = function (token, orderLegID, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads).concat(orderLegID, "/driver_update_bol_number/"), token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.updateLoadBOL = updateLoadBOL;
var updateFullLoad = function (token, loadID, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads).concat(loadID, "/"), token, 'PUT', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.updateFullLoad = updateFullLoad;
var fetchLoadByManifestLinkId = function (token, manifestLinkID) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "link/").concat(manifestLinkID, "/"), token, 'GET')];
}); }); };
exports.fetchLoadByManifestLinkId = fetchLoadByManifestLinkId;
var fetchOrderLegByOrderLegLinkId = function (token, orderLegLinkID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "link-leg/").concat(orderLegLinkID, "/"), token, 'GET')];
    });
}); };
exports.fetchOrderLegByOrderLegLinkId = fetchOrderLegByOrderLegLinkId;
var fetchOrderLegByBillOfLading = function (token, billOfLading) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "link-leg/").concat(billOfLading, "/"), token, 'GET')];
    });
}); };
exports.fetchOrderLegByBillOfLading = fetchOrderLegByBillOfLading;
var fetchAllOrderLegByOrderLegLinkId = function (token, orderLegLinkID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "link-leg/").concat(orderLegLinkID, "/get_all_order_legs_by_order_leg_link_id"), token, 'GET')];
    });
}); };
exports.fetchAllOrderLegByOrderLegLinkId = fetchAllOrderLegByOrderLegLinkId;
var fetchTruck = function (token, id, manifestLinkId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.trucks).concat(id, "/").concat(manifestLinkId ? "?s=".concat(manifestLinkId) : ''), token, 'GET')];
    });
}); };
exports.fetchTruck = fetchTruck;
var fetchVehicleType = function (token, id, manifestLinkId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.vehicleTypes).concat(id, "/").concat(manifestLinkId ? "?s=".concat(manifestLinkId) : ''), token, 'GET')];
    });
}); };
exports.fetchVehicleType = fetchVehicleType;
var fetchLoadTypes = function (token) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "types/"), token, 'GET')];
}); }); };
exports.fetchLoadTypes = fetchLoadTypes;
var fetchLoadUnits = function (token) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "units/"), token, 'GET')];
}); }); };
exports.fetchLoadUnits = fetchLoadUnits;
var fetchLoadETA = function (token, id, currentPosition) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        result = (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads).concat(id, "/ping/"), token, currentPosition ? 'POST' : 'GET', { 'Content-Type': 'application/json' }, currentPosition
            ? JSON.stringify((0, snakecase_keys_1.default)({
                latitude: currentPosition.latitude,
                longitude: currentPosition.longitude,
            }))
            : '');
        return [2 /*return*/, result];
    });
}); };
exports.fetchLoadETA = fetchLoadETA;
var fetchLoadETAByManifestLinkId = function (token, manifestLinkID, currentPosition) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        result = (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "link/").concat(manifestLinkID, "/ping/"), token, currentPosition ? 'POST' : 'GET', { 'Content-Type': 'application/json' }, currentPosition
            ? JSON.stringify((0, snakecase_keys_1.default)({
                latitude: currentPosition.latitude,
                longitude: currentPosition.longitude,
            }))
            : '');
        return [2 /*return*/, result];
    });
}); };
exports.fetchLoadETAByManifestLinkId = fetchLoadETAByManifestLinkId;
var fetchLegETAByLinkId = function (token, linkID, currentPosition) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        result = (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "link-leg/").concat(linkID, "/ping/"), token, currentPosition ? 'POST' : 'GET', { 'Content-Type': 'application/json' }, currentPosition
            ? JSON.stringify((0, snakecase_keys_1.default)({
                latitude: currentPosition.latitude,
                longitude: currentPosition.longitude,
            }))
            : '');
        return [2 /*return*/, result];
    });
}); };
exports.fetchLegETAByLinkId = fetchLegETAByLinkId;
var updateLoadStatus = function (token, loadID, transition, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads).concat(loadID, "/status/"), token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(__assign(__assign({}, (data || {})), { transitionFn: transition }))))];
    });
}); };
exports.updateLoadStatus = updateLoadStatus;
var dispatcherAssignDriver = function (token, loadID, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads).concat(loadID, "/dispatcher_assign_driver/"), token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.dispatcherAssignDriver = dispatcherAssignDriver;
var dispatcherUpdateLoadStatus = function (token, loadID, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads).concat(loadID, "/dispatcher_update_status/"), token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.dispatcherUpdateLoadStatus = dispatcherUpdateLoadStatus;
var dispatcherUpdatePriority = function (token, loadID, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads).concat(loadID, "/dispatcher_update_priority/"), token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.dispatcherUpdatePriority = dispatcherUpdatePriority;
var fetchLoadReport = function (token, id) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "reports/").concat(id, "/"), token, 'GET')];
}); }); };
exports.fetchLoadReport = fetchLoadReport;
var createLoadReport = function (token, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "reports/"), token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.createLoadReport = createLoadReport;
var updateLoadReport = function (token, id, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "reports/").concat(id, "/"), token, 'PATCH', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.updateLoadReport = updateLoadReport;
var deleteLoadReport = function (token, id) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "reports/").concat(id, "/"), token, 'DELETE')];
}); }); };
exports.deleteLoadReport = deleteLoadReport;
var fetchLoadDocument = function (token, documentID) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loadDocuments).concat(documentID, "/"), token, 'GET')];
}); }); };
exports.fetchLoadDocument = fetchLoadDocument;
var createLoadDocument = function (token, legID, document, includePhotos) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        data = new FormData();
        data.append('leg', "".concat(legID));
        data.append('document_type', document.documentType);
        data.append('comment', document.comment);
        console.log('[DEBUG] CREATELOADDOCUMENT data', data);
        if (includePhotos) {
            document.photos.forEach(function (_a) {
                var fullSize = _a.photo.fullSize, name = _a.name, type = _a.type;
                //@ts-ignore
                return data.append('add_photos', {
                    uri: fullSize,
                    name: name,
                    type: type,
                });
            });
        }
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loadDocuments), token, 'POST', { 'Content-Type': 'multipart/form-data' }, data)];
    });
}); };
exports.createLoadDocument = createLoadDocument;
var createLoadDocumentWeb = function (token, legID, document) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        data = new FormData();
        data.append('leg', "".concat(legID));
        data.append('document_type', document.documentType);
        data.append('comment', document.comment);
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loadDocuments, "create_web/"), token, 'POST', {}, data)];
    });
}); };
exports.createLoadDocumentWeb = createLoadDocumentWeb;
var updateLoadDocument = function (token, documentID, comment) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loadDocuments).concat(documentID, "/"), token, 'PATCH', { 'Content-Type': 'application/json' }, JSON.stringify({ comment: comment }))];
    });
}); };
exports.updateLoadDocument = updateLoadDocument;
var deleteLoadDocument = function (token, documentID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loadDocuments).concat(documentID, "/"), token, 'DELETE')];
    });
}); };
exports.deleteLoadDocument = deleteLoadDocument;
var createLoadDocumentPhotosWeb = function (token, documentID, photo) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        data = new FormData();
        data.append('photos', photo[0], photo[0].name);
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loadDocuments).concat(documentID, "/photos_web/"), token, 'PATCH', 
            // { 'Content-Type': 'multipart/form-data' },
            {}, data)];
    });
}); };
exports.createLoadDocumentPhotosWeb = createLoadDocumentPhotosWeb;
var createLoadDocumentFilesWeb = function (token, documentID, file) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        data = new FormData();
        data.append('file', file[0], file[0].name);
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loadDocuments).concat(documentID, "/files_web/"), token, 'PATCH', 
            // { 'Content-Type': 'multipart/form-data' },
            {}, data)];
    });
}); };
exports.createLoadDocumentFilesWeb = createLoadDocumentFilesWeb;
var createLoadDocumentPhotos = function (token, documentID, photos) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        data = new FormData();
        photos.forEach(function (_a) {
            var fullSize = _a.photo.fullSize, name = _a.name, type = _a.type;
            // @ts-ignore
            return data.append('photos', {
                uri: fullSize,
                name: name,
                type: type,
            });
        });
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loadDocuments).concat(documentID, "/photos/"), token, 'POST', { 'Content-Type': 'multipart/form-data' }, data)];
    });
}); };
exports.createLoadDocumentPhotos = createLoadDocumentPhotos;
var deleteLoadDocumentFilesWeb = function (token, documentID, ids) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loadDocuments).concat(documentID, "/files_web/"), token, 'DELETE', { 'Content-Type': 'application/json' }, JSON.stringify({ ids: ids }))];
    });
}); };
exports.deleteLoadDocumentFilesWeb = deleteLoadDocumentFilesWeb;
var deleteLoadDocumentPhotos = function (token, documentID, ids) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loadDocuments).concat(documentID, "/photos/"), token, 'DELETE', { 'Content-Type': 'application/json' }, JSON.stringify({ ids: ids }))];
    });
}); };
exports.deleteLoadDocumentPhotos = deleteLoadDocumentPhotos;
var fetchSavedTables = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "saved-tables/"), token, 'GET', { 'Content-Type': 'application/json' }, undefined, false)];
    });
}); };
exports.fetchSavedTables = fetchSavedTables;
var fetchSavedTable = function (token, savedTableId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "saved-tables/").concat(savedTableId, "/"), token, 'GET', { 'Content-Type': 'application/json' }, undefined, false)];
    });
}); };
exports.fetchSavedTable = fetchSavedTable;
var updateSavedTables = function (token, savedTableId, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "saved-tables/").concat(savedTableId, "/"), token, 'PATCH', { 'Content-Type': 'application/json' }, JSON.stringify(data), false)];
    });
}); };
exports.updateSavedTables = updateSavedTables;
var createSavedTable = function (token, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "saved-tables/"), token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify(data), false)];
    });
}); };
exports.createSavedTable = createSavedTable;
var deleteSavedTable = function (token, savedTableId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "saved-tables/").concat(savedTableId, "/"), token, 'DELETE')];
    });
}); };
exports.deleteSavedTable = deleteSavedTable;
var rotatePhotoRight = function (token, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loadDocumentPhotos).concat(id, "/rotate_right/"), token, 'POST')];
    });
}); };
exports.rotatePhotoRight = rotatePhotoRight;
var driverUpdateDwellTime = function (token, loadID, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads).concat(loadID, "/driver_update_dwell_time/"), token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.driverUpdateDwellTime = driverUpdateDwellTime;
var getAllPaperworks = function (token, loadID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads).concat(loadID, "/get_all_paperworks/"), token, 'GET')];
    });
}); };
exports.getAllPaperworks = getAllPaperworks;
var createEquipmentReport = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "equipment-reports/create-report/"), token, 'POST')];
    });
}); };
exports.createEquipmentReport = createEquipmentReport;
var sendEquipmentReport = function (token, report) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "equipment-reports/").concat(report.id, "/send-report/"), token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(report)))];
    });
}); };
exports.sendEquipmentReport = sendEquipmentReport;
var createEquipmentReportPhotos = function (token, reportID, photos) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        data = new FormData();
        photos.forEach(function (_a) {
            var fullSize = _a.photo.fullSize, name = _a.name, type = _a.type;
            // @ts-ignore
            return data.append('photos', {
                uri: fullSize,
                name: name,
                type: type,
            });
        });
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "equipment-reports/").concat(reportID, "/photos/"), token, 'POST', { 'Content-Type': 'multipart/form-data' }, data)];
    });
}); };
exports.createEquipmentReportPhotos = createEquipmentReportPhotos;
var deleteEquipmentReportPhotos = function (token, reportID, ids) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "equipment-reports/").concat(reportID, "/photos/"), token, 'DELETE', { 'Content-Type': 'application/json' }, JSON.stringify({ ids: ids }))];
    });
}); };
exports.deleteEquipmentReportPhotos = deleteEquipmentReportPhotos;
var createDriverLoadReport = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "driver-load-reports/create-report/"), token, 'POST')];
    });
}); };
exports.createDriverLoadReport = createDriverLoadReport;
var sendDriverLoadReport = function (token, report) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "driver-load-reports/").concat(report.id, "/send-report/"), token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(report)))];
    });
}); };
exports.sendDriverLoadReport = sendDriverLoadReport;
var createDriverLoadPhotos = function (token, reportID, photos) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        data = new FormData();
        photos.forEach(function (_a) {
            var fullSize = _a.photo.fullSize, name = _a.name, type = _a.type;
            // @ts-ignore
            return data.append('photos', {
                uri: fullSize,
                name: name,
                type: type,
            });
        });
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "driver-load-reports/").concat(reportID, "/photos/"), token, 'POST', { 'Content-Type': 'multipart/form-data' }, data)];
    });
}); };
exports.createDriverLoadPhotos = createDriverLoadPhotos;
var createDriverLoadDocuments = function (token, reportID, documents) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        data = new FormData();
        documents.forEach(function (_a) {
            var fullSize = _a.photo.fullSize, name = _a.name, type = _a.type;
            // @ts-ignore
            return data.append('documents', {
                uri: fullSize,
                name: name,
                type: type,
            });
        });
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "driver-load-reports/").concat(reportID, "/photos/"), token, 'POST', { 'Content-Type': 'multipart/form-data' }, data)];
    });
}); };
exports.createDriverLoadDocuments = createDriverLoadDocuments;
var deleteDriverLoadPhotos = function (token, reportID, photo_ids) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "driver-load-reports/").concat(reportID, "/photos/"), token, 'DELETE', { 'Content-Type': 'application/json' }, JSON.stringify({ photo_ids: photo_ids }))];
    });
}); };
exports.deleteDriverLoadPhotos = deleteDriverLoadPhotos;
var deleteDriverLoadDocuments = function (token, reportID, document_ids) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "driver-load-reports/").concat(reportID, "/photos/"), token, 'DELETE', { 'Content-Type': 'application/json' }, JSON.stringify({ document_ids: document_ids }))];
    });
}); };
exports.deleteDriverLoadDocuments = deleteDriverLoadDocuments;
var createPhotoIssueReport = function (token, legId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "photo-issue-reports/create-photo-report/"), token, 'POST', { 'Content-Type': 'application/json' }, JSON.stringify({ leg_id: legId }))];
    });
}); };
exports.createPhotoIssueReport = createPhotoIssueReport;
var updatePhotoIssueReport = function (token, id, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, base_1.callApiWithToken)("".concat(config_1.default.urls.loads, "photo-issue-reports/").concat(id, "/"), token, 'PATCH', { 'Content-Type': 'application/json' }, JSON.stringify((0, snakecase_keys_1.default)(data)))];
    });
}); };
exports.updatePhotoIssueReport = updatePhotoIssueReport;
